import handleNalError from '@js/core/handleNalError.js';

export function apiCall(method, url, data = null, options = {}) {
    window.jwt.handleOutlookRequest();

    return $.ajax({
        method,
        url: url,
        data: data && JSON.stringify(data),
        contentType: 'application/json',
    }).done(response => {
        if (response?.redirect) {
            return window.location.replace(response.redirect);
        }
    }).fail(error => {
        handleNalError(
            error,
            window.nal?.project,
            options.silencedErrors,
            options.handleAuthenticationError
        );
    });
}

export function apiGet(url, data, options) {
    return apiCall('get', url, data, options);
}

export function apiDelete(url, data) {
    return apiCall('delete', url, data);
}

export function apiPost(url, data, options) {
    return apiCall('post', url, data, options);
}

export function apiPut(url, data, options) {
    return apiCall('put', url, data, options);
}
